<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'doctorAdd'" @click="addAssistant" v-if="role_id != 2">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</span>姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</span>手机号码：</span>
                <el-input v-model="mobile" placeholder="模糊搜索手机号码"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状&ensp;&ensp;&ensp;&ensp;态：</span>
                <el-select
                    clearable
                    class="status"  v-model="status" placeholder="请选择状态" style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">

            <el-col :md="6" :lg="5" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">关联特属服务对象：</span>
                <el-input v-model="client_user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属服务对象手机号码：</span>
                <el-input v-model="client_user_mobile" placeholder="特属服务对象手机号码模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="12" :xs="24" v-if="role_id != 2">
                <span class="fs-14 pd-r-10">所属集团：</span>
                <el-select
                    clearable
                    class="status"  v-model="bloc_id" placeholder="请选择所属集团" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allBloc"
                        :key="item.id"
                        :label="item.bloc_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24" v-if="role_id != 2">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons" v-if="role_id != 2 && role_id != 24">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_mobile" label="登录手机号码" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bloc_name" label="所属集团" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="client_user_name" label="关联特属服务对象" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="client_user_mobile" label="特属服务对象手机号码" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
                    v-if="role_id != 2"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopUser(scope.row,2)" v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopUser(scope.row,1)" v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'hospitalDel'" @click="resetUserPassword(scope.row)" type="text"
                           size="small">重置密码
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";
    import {authUrlCheck, isMobile} from "@/api/order";

    export default {
        data() {
            return {
                role_id: 0,
                allStatus: [
                    {
                        id: 1,
                        name: '启用',
                    },
                    {
                        id: 2,
                        name: '停用',
                    },
                ],
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                mobile: '',
                status: '',
                bloc_id: '',
                client_user_name: '',
                client_user_mobile: '',
                allBloc: [],
                is_submit: false,
                is_pagination_show: true,
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created(){
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            let q_user_name = this.$route.query.user_name;
            this.client_user_name = q_user_name;
        },
        mounted() {
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'assistant_add' || prev_page == 'assistant_edit' || prev_page == 'assistant_detail') {
                this.user_name = localStorage.getItem('assistant_list_user_name')
                this.mobile = localStorage.getItem('assistant_list_mobile')
                this.status = parseInt(localStorage.getItem('assistant_list_status'))||''
                this.bloc_id = localStorage.getItem('assistant_list_bloc_id')
                this.client_user_name = localStorage.getItem('assistant_list_client_user_name')
                this.client_user_mobile = localStorage.getItem('assistant_list_client_user_mobile')
                if (this.client_user_name == 'undefined' || this.client_user_name == 'null') {
                    this.client_user_name = ''
                }
                if (this.client_user_mobile == 'undefined' || this.client_user_mobile == 'null') {
                    this.client_user_mobile = ''
                }
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.status == 'undefined' || this.status == 'null') {
                    this.status = ''
                }
                if (this.bloc_id == 'undefined' || this.bloc_id == 'null') {
                    this.bloc_id = ''
                }
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                this.is_pagination_show = false;
                setTimeout(function () {
                    localStorage.setItem('prev_page', 'assistant_list')
                }, 700)

            }
            this.getList();
            this.getAllBloc();
        },
        methods: {
            // 获取所有子账号
            getList() {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'userAssistantListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        status: this.status,
                        bloc_id: this.bloc_id,
                        client_user_name: this.client_user_name,
                        client_user_mobile: this.client_user_mobile,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        // 以序号代替ID
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = '1';
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = '2';
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;

                    localStorage.setItem('assistant_list_user_name', this.user_name)
                    localStorage.setItem('assistant_list_mobile', this.mobile)
                    localStorage.setItem('assistant_list_status', this.status)
                    localStorage.setItem('assistant_list_bloc_id', this.bloc_id)
                    localStorage.setItem('assistant_list_client_user_name', this.client_user_name)
                    localStorage.setItem('assistant_list_client_user_mobile', this.client_user_mobile)

                    localStorage.setItem('prev_page', 'assistant_list')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                }).catch( err => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
                this.is_pagination_show = true
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_name = "";
                this.mobile = "";
                this.status = "";
                this.bloc_id = "";
                this.client_user_name = "";
                this.client_user_mobile = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;

                this.page = 1;
                this.getList();
            },

            goEdit(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/user/AssistantEdit', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "assistantEdit", params: {
                        user_id: data.user_id,
                        user_name: data.user_name,
                        client_user_name: data.client_user_name,
                        mobile: data.user_mobile,
                        client_id: data.client_user_id,
                        status: data.status_number,
                        user_avatar: data.user_avatar,
                    }
                });
                return;
            },

            // 新增子账户
            addAssistant() {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/user/AssistantAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "assistantAdd", params: {}});
                return;
            },

            // 启用子账户
            startStopUser(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;

                var message = '';
                if (status == '1') {
                    message = '确定启用该子账号吗？'
                }
                if (status == '2') {
                    message = '确定停用该子账号吗？'
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminCustomerServices',
                        method: 'startStopUserAssistant',
                        params: {
                            user_id: data.user_id,
                            status: status,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '操作成功'
                            });
                        }
                        this.getList();
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                });
            },

            // 获取所有集团
            getAllBloc() {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'allBloc',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allBloc = res.data.data;
                });
            },

            // 重置密码
            resetUserPassword(data) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定重置该子账号的密码吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminCustomerServices',
                        method: 'resetUserAssistantPassword',
                        params: {
                            user_id: data.user_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '重置成功',
                            duration: 1500,
                        });
                    });
                }).catch(() => {
                    this.is_submit = false;
                });
            },


            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'exportUserAssistantExcel',
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        status: this.status,
                        bloc_id: this.bloc_id,
                        client_user_name: this.client_user_name,
                        client_user_mobile: this.client_user_mobile,
                    },
                };
                let colums_list = [
                    {title: "ID", key: "user_id"},
                    {title: "登录手机号码", key: "user_mobile"},
                    {title: "姓名", key: "user_name"},
                    {title: "所属集团", key: "bloc_name"},
                    {title: "关联特属服务对象", key: "client_user_name"},
                    {title: "特属服务对象手机号码", key: "client_user_mobile"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        let is_expired;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }
                        let item = {
                            user_id: res_data.data[i].user_id,
                            user_mobile: res_data.data[i].user_mobile,
                            user_name: res_data.data[i].user_name,
                            bloc_name: res_data.data[i].bloc_name,
                            client_user_name: res_data.data[i].client_user_name,
                            client_user_mobile: res_data.data[i].client_user_mobile,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出子账户");
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(() => {
                    this.is_submit = false;
                });
            },

        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .inputs .el-select {
        max-width: none !important;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
